import type { QuestionnaireResponse } from "@medplum/fhirtypes";

import {
  FETAL_HEART_RATE_DATE_LINK_ID,
  FETAL_HEART_RATE_DATE_TIME_LINK_ID,
  FETAL_HEART_RATE_TIME_LINK_ID,
} from "@/encounters/components/EncounterLabor/flowsheet-forms/fetal-heart-rate/constants/fetal-heart-rate-link-ids";
import { findQuestionnaireResponseItem } from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/questionnaire-response-readers";
import { resolveFetalHeartRateRootGroup } from "@/encounters/components/EncounterLabor/utils/resolve-fetal-heart-rate-root-group";
import { buildEffectiveDateTimeFromUtcParts } from "@/utils/datetime";

export interface FhrClinicalDateTimeParts {
  valueDate?: string;
  valueTime?: string;
  effectiveDateTime?: string;
  effectiveAtMs?: number;
}

/** Reads FHR clinical date/time from a questionnaire response (no meta.lastUpdated fallback). */
export function readFhrClinicalDateTimeFromResponse(
  response: QuestionnaireResponse,
): FhrClinicalDateTimeParts {
  const fetalHeartRateGroup = resolveFetalHeartRateRootGroup(response.item);
  if (!fetalHeartRateGroup?.item) {
    return {};
  }

  const dateTimeGroup = findQuestionnaireResponseItem(
    fetalHeartRateGroup.item,
    FETAL_HEART_RATE_DATE_TIME_LINK_ID,
  );
  const valueDate = findQuestionnaireResponseItem(
    dateTimeGroup?.item,
    FETAL_HEART_RATE_DATE_LINK_ID,
  )?.answer?.[0]?.valueDate;
  const valueTime = findQuestionnaireResponseItem(
    dateTimeGroup?.item,
    FETAL_HEART_RATE_TIME_LINK_ID,
  )?.answer?.[0]?.valueTime;
  const effectiveDateTime = buildEffectiveDateTimeFromUtcParts(valueDate, valueTime);
  const effectiveAtMs = effectiveDateTime ? Date.parse(effectiveDateTime) : undefined;

  return {
    valueDate,
    valueTime,
    effectiveDateTime,
    effectiveAtMs:
      effectiveAtMs !== undefined && !Number.isNaN(effectiveAtMs) ? effectiveAtMs : undefined,
  };
}
